import useChangeDraft from '@/features/dashboard/bookingChanges/hooks/useChangeDraft.ts';
import useGetChangeHistory from '@/features/dashboard/bookingChanges/hooks/useGetChangeHistory.ts';
import { toChangePackageStatus } from '@/features/dashboard/bookingChanges/types/BookingChangeDetailDto.mapper.ts';
import { ChangePackageStatus } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';
import RecentChangesCard from './RecentChangesCard';
import RecentChangesCardSkeleton from './RecentChangesCardSkeleton';

interface RecentChangesSectionProps {
  bookingId: string;
}

/**
 * Ostatnie zmiany — panel boczny w trybie podglądu. Szkic stoi nad historią,
 * więc karta czeka na oba zapytania naraz.
 */
const RecentChangesSection = ({ bookingId }: RecentChangesSectionProps) => {
  const historyQuery = useGetChangeHistory(bookingId);
  const {
    draft,
    change,
    isLoading: isDraftLoading,
  } = useChangeDraft(bookingId);

  if (historyQuery.isLoading || isDraftLoading) {
    return <RecentChangesCardSkeleton />;
  }

  const history = historyQuery.data ?? [];
  /*
   * Wyróżniony wiersz należy się wyłącznie szkicowi. Paczka czekająca na klienta
   * też jest „otwarta” (blokuje edycję, więc `useChangeDraft` musi ją widzieć),
   * ale nie czeka na wprowadzenie i stoi już w historii — bez tego warunku ta
   * sama paczka pokazuje się dwa razy, raz pod cudzą etykietą.
   */
  const openDraft =
    change && toChangePackageStatus(change.status) === ChangePackageStatus.DRAFT
      ? (draft ?? undefined)
      : undefined;

  return openDraft || history.length > 0 ? (
    <RecentChangesCard draft={openDraft} history={history} />
  ) : null;
};

export default RecentChangesSection;
